import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB_I3oeWOoKQhKdRzg9wgHXYJeQc76Kd5Q",
  authDomain: "ushakiran-medicos.firebaseapp.com",
  projectId: "ushakiran-medicos",
  storageBucket: "ushakiran-medicos.firebasestorage.app",
  messagingSenderId: "261000395630",
  appId: "1:261000395630:web:aeb1e2df8138f56f419f7f",
  measurementId: "G-3CE02S8B92"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };